import { createSlice } from '@reduxjs/toolkit'

const TorkSlice = createSlice({
  name: 'TorkSlice',
  initialState: [],
  reducers: {
    setTorks(state, action) {
      return [...action.payload];
    },
    addTork(state, action) {
      if (state.some(t => t.id === action.payload.id)) return state;
      return [...state, action.payload];
    },
    updateTork(state, action) {
      return state.map(t => t.id === action.payload.id ? action.payload : t);
    },
    removeTork(state, action) {
      return state.filter(t => t.id !== action.payload.id);
    }
  }
})

export const { setTorks, addTork, updateTork, removeTork } = TorkSlice.actions
export default TorkSlice.reducer
